import { UserContextError } from "@dashboard/auth/types";
import { defineMessages, IntlShape } from "react-intl";

export const errorMessages = defineMessages({
  loginError: {
    id: "FopBSj",
    defaultMessage: "Your username and/or password are incorrect. Please try again.",
    description: "error message",
  },
  unknownLoginError: {
    id: "Wr5UOV",
    defaultMessage: "Login went wrong. Please try again.",
    description: "error message",
  },
  serverError: {
    id: "ChGI4V",
    defaultMessage: "Saleor is unavailable, please check your network connection and try again.",
    description: "error message",
  },
  noPermissionsError: {
    id: "7Jg9ec",
    defaultMessage: "You don't have permission to login.",
    description: "error message",
  },
  loginAttemptDelay: {
    defaultMessage: "Please wait a moment before trying again.",
    description: "error message",
    id: "RyZd9J",
  },
});

export const wsmSsoMessages = defineMessages({
  signIn: {
    id: "aabUlC",
    defaultMessage: "Sign in with Web Shop Manager",
    description: "button",
  },
  manageSignIn: {
    id: "spGoeO",
    defaultMessage: "Manage sign-in",
    description: "button",
  },
  providerUnavailable: {
    id: "fpqAcI",
    defaultMessage: "Sign-in service unavailable, try again",
    description: "error message",
  },
  // The one refusal with no words of its own, so the code is the message: this bundle
  // has never heard of it and support needs something to search for.
  refusalCode: {
    id: "s62nEF",
    defaultMessage: "Staff sign-in refused, code {code}",
    description: "error message",
  },
});

export function getErrorMessage(err: UserContextError, intl: IntlShape): string {
  switch (err) {
    case "loginError":
      return intl.formatMessage(errorMessages.loginError);
    case "externalLoginError":
      return intl.formatMessage(errorMessages.unknownLoginError);
    case "unknownLoginError":
      return intl.formatMessage(errorMessages.unknownLoginError);
    case "serverError":
      return intl.formatMessage(errorMessages.serverError);
    case "noPermissionsError":
      return intl.formatMessage(errorMessages.noPermissionsError);
    case "loginAttemptDelay":
      return intl.formatMessage(errorMessages.loginAttemptDelay);
    case "invalidCredentials":
      return intl.formatMessage(errorMessages.loginError);
    default:
      return intl.formatMessage(errorMessages.unknownLoginError);
  }
}
